<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <mat-form-field class="w-full">
    <mat-select
      [multiple]="multiple"
      [value]="value"
      [placeholder]="placeholder | translate"
      (selectionChange)="onSelectChange($event.value)"
      [disabled]="isDisabled"
      panelClass="lg-panel-class">
      <div class="flex flex-row justify-center items-center w-full h-9">
        <input
          matInput
          *ngIf="hasSearch"
          class="flex w-full px-3 box-border"
          #inputElement
          (keydown)="$event.stopPropagation()" />
        <button type="button" class="p-1 mr-1 rounded-full hover:bg-neutral-100 active:bg-neutral-300" (click)="clearSearchText()">
          <app-icon iconName="x" size="sm" stroke="#202020"></app-icon>
        </button>
      </div>

      <mat-divider *ngIf="hasSearch"></mat-divider>

      <div *ngIf="selectAll && options.length > 0 && multiple" class="flex flex-row items-center  border-b border-neutral-200">
        <div class="flex flex-row w-full items-center py-2 px-3 gap-1 cursor-pointer hover:bg-neutral-100" (click)="toggleSelectAll()">
          <app-icon [ngStyle]="{cursor:'pointer'}" size="md" [iconName]="isAllSelected ? 'close' : 'check'"></app-icon>
          <span class="ml-1">{{ (isAllSelected ? 'global.deselectAll' : 'global.selectAll') | translate }}</span>
        </div>
      </div>

      <div *ngIf="hasSearch" class="flex flex-col px-3 py-2 border-b border-neutral-200">
        <span class="text-sm">{{'exposures.lastSearchResults' | translate:{count: options.length} }}</span>
        <i class="text-xs text-gray-500">{{ 'exposures.useSearchForMore' | translate }}</i>
      </div>
      <mat-option *ngIf="includeInactive" [value]="-1" class="font-bold" [disabled]="options.length === 0">
        <span class="px-1">{{ includeInactiveLabel | translate }}</span>
      </mat-option>

      <mat-option *ngFor="let data of options" [value]="data.id">
        <div class="flex items-center gap-1">
          <span *ngIf="data.label" class="font-semibold shrink-0 px-1 py-0.5 rounded text-brand-bright-orange">
            {{ data.label }}
          </span>
          <span [innerHTML]="data.name | BoldTextPipe:(data.id === -1)"></span>
        </div>
      </mat-option>
      <div class="flex flex-row px-3 py-3 justify-between border-t border-neutral-200" *ngIf="hasSearch">
        <button
          class="cursor-pointer text-sm italic underline text-brand-chathams-blue hover:text-opacity-80 disabled:text-gray-600"
          [disabled]="options.length >= params?.totalCount"
          (click)="$event.stopPropagation(); loadMore()">
          {{ 'exposures.showMore' | translate }}
        </button>

        <button class="ml-3 cursor-pointer text-sm italic underline text-brand-red hover:text-opacity-80" (click)="clearSelection()">
          {{ 'global.clearSelection' | translate }}
        </button>
      </div>
    </mat-select>
  </mat-form-field>
</div>
